'use strict';

import L from "leaflet";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.factory("obsStrateDefaultConfig", function () {
    return {
        defaultStyle: {
            weight: 2,
            opacity: 1,
            color: '#322f8f',
            dashArray: 3
        },
        hoverStyle: {
            color: "#F48600",
            dashArray: 0,
            weight: 4
        },
        selectedStyle: {
            color: "#46c014",
            dashArray: 0,
            weight: 5
        },
        referenceStyle: {
            color: "#A52694",
            dashArray: 0,
            weight: 5
        },
        noValueStyle: {
            fillOpacity: 0
        },
        gradientStops: [
            "#fffee9",
            "#fff9c8",
            "#ffe5b8",
            "#f7d3b3",
            "#e1c4b4",
            "#cebbb7"
        ]
    };
});

ngModule.factory("ObsStratManager", function ($numberFormat, colorUtils, obsStrateDefaultConfig) {

    return function ObsStratManager(cfg) {

        var manager = this,
            config = $.extend(true, angular.copy(obsStrateDefaultConfig), cfg || {}),
            gradient,
            strates;

        var findStrateForValue = function (value) {
            if (value == null || value === "HORS_FILTRE") {
                return config.noValueStyle;
            }
            var min, max;
            for (var i = strates.length-1; i >=0 ; i--) {
                min = strates[i].min;
                max = strates[i].max;

                // pour la prmiere state on est par exemple sur du <0. Donc on prend aussi le 0
                if (i===strates.length-1 && min== null && max ===value) {
                    return strates[i];
                }

                if (((min == null || value >= min) && (max == null || value < max) || (min===max && value===min))) {
                    return strates[i];
                }
            }
            return config.noValueStyle;
        };

        manager.setStrates = function (_strates) {

            gradient = colorUtils.generateGradient(config.gradientStops, _strates.length);

            strates = _.map(_strates, function (strate, i) {
                return _.extend(strate, {
                    color: strate.color || gradient[i],
                    fillOpacity: 0.7
                });
            });
        };

        manager.getGeoStyle = function (feature) {
            if (feature.properties.repere) {
                return _.extend({}, config.defaultStyle, {
                    color: "#FF0000",
                    fillOpacity: 0
                });
            }

            var value = feature.properties.value;
            var palier = findStrateForValue(value);

            var style = _.extend({}, config.defaultStyle, {
                fillColor: palier.color,
                fillOpacity: palier.fillOpacity
            });

            return style;
        };

        manager.generateLegend = function () {
            var legend = L.control({
                position: "bottomright"
            });
            legend.onAdd = function () {
                var div = $("<div>").addClass("control obs-legend");
                _.each(strates.reverse(), function (palier) {
                    div.append('<div><i style="background:' + palier.color + '"></i>' + palier.label + '</div>');
                });
                return div[0];
            };
            return legend;
        };

        manager.getConfig = function () {
            return config;
        };

    };

});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/utils/obsStratManager.js